import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		const sliders = document.querySelectorAll(".content-video-carousel .splide");
		if (!sliders.length) return;

		sliders.forEach((slider) => {
			// Cache each iframe's YouTube src before Splide touches the DOM
			slider.querySelectorAll("iframe").forEach((iframe) => {
				iframe.dataset.ytSrc = iframe.src;
			});

			const splide = new Splide(slider, {
				type: "slide",
				perPage: 1,
				arrows: true,
				pagination: true,
				gap: "1.5rem",
				accessibility: true,
                breakpoints: {
                    640: {
                        arrows: false
                    },
                }
			});

			// Blank the departing slide's iframe the moment navigation starts —
			// navigating to about:blank is the only guaranteed way to stop a video
			// regardless of whether the YouTube IFrame API is available.
			splide.on("move", (newIndex, prevIndex) => {
				const slides = slider.querySelectorAll(".splide__slide");
				const prevIframe = slides[prevIndex]?.querySelector("iframe");
				if (prevIframe) {
					prevIframe.src = "about:blank";
				}
			});

			// After the transition completes, reload the arriving slide's embed
			// so it's ready for the user to play (resets to the beginning).
			splide.on("moved", (newIndex) => {
				const slides = slider.querySelectorAll(".splide__slide");
				const nextIframe = slides[newIndex]?.querySelector("iframe");
				if (nextIframe?.dataset.ytSrc && nextIframe.src !== nextIframe.dataset.ytSrc) {
					nextIframe.src = nextIframe.dataset.ytSrc;
				}
			});

			splide.mount();
		});
	})
	.catch(console.error);
